import { Text, VStack } from "@chakra-ui/react";
import type { EstimatedCoverage } from "api/types";
import { LazyDeviationReasonSelect } from "components/deviationReason/LazyDeviationReasonSelect";

export type PeriodDeviationReasonCellProps = {
  productId: number;
  erpCode: string;
  periodIndex: number;
  targetDate: EstimatedCoverage["targetDate"];
  chronologyParameter: string;
  value: string | null;
  valueLabel?: string | null;
  canEdit: boolean;
  onChange: (input: {
    productId: number;
    erpCode: string;
    periodIndex: number;
    targetDate: EstimatedCoverage["targetDate"];
    chronologyParameter: string;
    deviationNoteId: string | null;
    deviationNoteLabel?: string;
  }) => void;
};

/** Selector de motivo de desviación por período. */
export function PeriodDeviationReasonCell(props: PeriodDeviationReasonCellProps) {
  const {
    productId,
    erpCode,
    periodIndex,
    targetDate,
    chronologyParameter,
    value,
    valueLabel,
    canEdit,
    onChange,
  } = props;

  return (
    <VStack align="stretch" spacing={1} px="0" w="100%">
      <Text fontSize="9px" color="gray.500" textAlign="left">
        Motivo
      </Text>
      <LazyDeviationReasonSelect
        value={value ?? ""}
        selectedLabel={valueLabel}
        isDisabled={!canEdit}
        placeholder={canEdit ? "Elegir…" : "—"}
        size="sm"
        optionValue="id"
        onChange={(deviationNoteId, label) =>
          onChange({
            productId,
            erpCode,
            periodIndex,
            targetDate,
            chronologyParameter,
            deviationNoteId: deviationNoteId === "" ? null : deviationNoteId,
            deviationNoteLabel: label,
          })
        }
      />
    </VStack>
  );
}
